<template>
    <div :style="{maxWidth:screenWidth}">
        <el-form :model="emForm"  :rules="rules" ref="emFormRef">
            <el-card class="box-card">
                <h3>Basic Settings</h3>
            <el-row :gutter="5">
                <el-col :span="4">
                    <el-form-item prop="email_server" label="Email Server">
                        <el-input  v-model="emForm.email_server" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item prop="email_port" label="Email Port">
                        <el-input  v-model="emForm.email_port" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item prop="emial_username" label="Emial Username">
                        <el-input  v-model="emForm.emial_username" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item prop="email_psd" label="Email Psd">
                        <el-input  v-model="emForm.email_psd" type="password" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item prop="email_name" label="Email NickName">
                        <el-input  v-model="emForm.email_name" ></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="3">
                    <el-form-item prop="secure" label="Secure">
                        <el-input  v-model="emForm.secure"  ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            </el-card>
            <el-card class="box-card">
                <h3>Message when RMA is updated</h3>
            <el-row :gutter="5">
                <el-col :span="8">
                    <el-form-item prop="rma_create" label="Rma Create">
                        <el-input  v-model="emForm.rma_create" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item prop="rma_registration" label="RMA Registration">
                        <el-input  v-model="emForm.rma_registration" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="rma_response" label="Rma Response">
                        <el-input  v-model="emForm.rma_response" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
                    </el-form-item>
                </el-col>


            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item prop="shipping1" label="Shipping (Customer→BTI Wireless)">
                        <el-input  v-model="emForm.shipping1" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="progress" label="Progress Update">
                        <el-input  v-model="emForm.progress" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="shipping2" label="Shipping(BTI Wireless→Customer) Customer  ">
                        <el-input  v-model="emForm.shipping2" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
                    </el-form-item>
                </el-col>

            </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item prop="shipping3" label="Shipping(BTI Wireless→Customer) BTI Wireless  ">
                            <el-input  v-model="emForm.shipping3" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item prop="c_register_cou" label="Correspondence Register(by Customer)">
                            <el-input  v-model="emForm.c_register_cou" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item prop="c_register_sun" label="Correspondence Register(by BTI Wireless )">
                            <el-input  v-model="emForm.c_register_sun" type="textarea" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-card>
        </el-form>

        <span slot="footer" class="dialog-footer" >
                <el-button type="primary" @click="add" >SUBMIT</el-button>
            </span>

    </div>
</template>

<script>
    var token =  localStorage.getItem('token')
    export default {
        name: "emAdd.vue",
        data(){
            return{
                screenWidth: document.body.clientWidth-310 + "px",
                isdowning:false,
                emForm:{

                },
                role:"",
                fileList:[],
                myHeaders: {token: token},
                link:[],
                urFormVisible:false,
                rules:{

                },

            }

        },
        async created() {
            this.role=localStorage.getItem("role");
            this.getInfo()
            document.title = "EMAIL SETTING - Welcome to BTI Wireless’s RMA Process System";

        },
        methods:{
            async getInfo(){
                const result=await this.$http.get("email/info");
                if (result.data.error_code!==0){

                }else {
                    this.emForm=result.data.data;
                }



            },
            async add() {
                this.$refs.emFormRef.validate(async valid => {
                    if (!valid) {
                        console.log('error submit!!');
                        return false;
                    }
                    console.log(this.emForm)
                    const result=await this.$http.post("email/add",this.emForm);
                    if (result.data.error_code!==0){
                        this.$message.error(result.data.msg);
                    }else {
                        this.$message.success(result.data.msg);
                        this.$router.push('/rmaList');
                    }
                });
            },
        }
    }
</script>

<style lang="less" scoped>
    .el-table{

    }
    .el-breadcrumb{
        padding-top: 10px;
    }
    .el-card{
        margin-bottom: 5px;
    }
    .el-table{
        margin-bottom: 5px;
    }
    .el-table-column{
        padding-left: 10px;
    }
    .el-form{
        width: 100%;
    }
    .el-select{
        width: 100%;
    }
    .el-image{
        width: 25%;
        margin: 5px;
        max-width: 150px;
    }
    .el-form{
        margin-bottom: 20px;
    }
</style>
